import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSubject } from "../../context/SubjectContext";
import "./MarkSubmissionUpdateMarks.css";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useApi } from "../../context/ApiClient";
import { useCenter } from "../../context/CenterContext";
import {
  MARK_STATUS,
} from "../../constants/Constants";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
import { getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";

const MarkSubmissionUpdateMarks = ({ candidates = [] }) => {
  const location = useLocation();
  const { subjectData } = useSubject();
  const { selectedSubject } = subjectData || {};

  const subjectId = subjectData?.selectedSubjectId;
  const navigate = useNavigate();
  const { centerNumber } = useCenter();
  const { sessionId, isPostStage3 } = location.state || {};

  const [sortKey, setSortKey] = useState("candidateName");
  const [sortDirection, setSortDirection] = useState("asc");

  const { subject, unit } = useParams();
    const { consortiaCentres = [] } = useConsortiaCenter();
  
const currentCentreType =
    getCenterType(consortiaCentres, Number(centerNumber), subjectData?.selectedSubject, subjectData?.selectedSubjectId) || "";
  const consortiaUnitcode =
    String(unit ?? "")
      .toUpperCase()
      .match(/^[A-Z0-9]+/)?.[0] || "";
  const isConsortiaUnit = checkunitIsConsortiaUnit(
    consortiaCentres,
    centerNumber,
    sessionId,
    consortiaUnitcode,
  );
  // Get rows from navigate state if available
  const passedRows = location.state?.rows;

  const [rows, setRows] = useState(
    passedRows ||
    candidates.map((c) => ({
      candidateNumber: c.candidateNumber,
      markAsAbsent: c.markAsAbsent ?? false,
      totalCriteriaAchieved: c.totalCriteriaAchieved ?? "",
      assignmentId: c.assignmentId ?? "", // will be 10, 11, or 59
      markStatusId: c.markStatusId ?? 25, // default to "Submitted"
      centreNumber: c.centreNumber ?? 33319,
      sessionId: c.sessionId ?? 3381,
      subjectId: c.subjectId ?? 1,
      assessmentCode: c.assessmentCode ?? "F182",
      insertedDate: new Date().toISOString(),
      insertedBy: "",
    }))
  );

  const api = useApi(process.env.REACT_APP_AMS_BASE_URL);

  const transformRows = (rows) => {
    const unitCode = location.state.unit.split(" ")[0];

    return rows.map((row) => {
      if (row.markAsAbsent) {
        return {
          candidateNumber: row.candidateNumber, // add candidate Name if required
          markAsAbsent: true,
          totalCriteriaAchieved: null,
          assignmentId: null,
          markStatusId: isPostStage3 ? MARK_STATUS.RE_RESUBMITTED : 
            row.isSampled === true
              ? MARK_STATUS.RESUBMITTED
              : null,
          centreNumber: row.centreNumber || centerNumber,
          sessionId: sessionId,
          subjectId: subjectId,
          assessmentCode: unitCode,
          insertedDate: "2025-09-09T19:22:52.726",
          insertedBy: "test",
        };
      }

      return {
        candidateNumber: row.candidateNumber,
        markAsAbsent: false,
        totalCriteriaAchieved: row.disableCandidate ? null : Number(row.totalCriteriaAchieved),
        assignmentId: row.assignmentId || null,
        markStatusId:
        isPostStage3 ? MARK_STATUS.RE_RESUBMITTED : 
          (!row.markStatus || row.markStatus === "Saved") &&
            (row.isSampled === false || !row.isSampled)
            ? MARK_STATUS.SUBMITTED
            : row.markStatus === "Saved" && row.isSampled === true
              ? MARK_STATUS.RESUBMITTED
              : null,
        centreNumber:  row.centreNumber || centerNumber,
        sessionId: sessionId,
        subjectId: subjectId,
        assessmentCode: unitCode,
        insertedDate: "2025-09-09T19:22:52.726",
        insertedBy: "test",
      };
    });
  };

  const submitMarks = async () => {
    const payload = transformRows(rows);
     if (isConsortiaUnit === undefined || isConsortiaUnit === null) {
      return;
    }
    try {
       const submitEndpoint =
        currentCentreType === "Lead" && isConsortiaUnit
          ? "consortia/submitCandidateMarks"
          : "submitCandidateMarks";
      const response = await api.post(submitEndpoint, payload);

      if (response.status === 200) {
        toast.success("Your total marks have been updated", {
          duration: 5000,
          style: { minWidth: "350px" },
        });
        navigate(`/dashboard/marks_submission/${selectedSubject}`);
      } else {
        console.error("Failed to update marks", response);
      }
    } catch (error) {
      console.error("Error updating marks", error);
    } finally {

    }
  };

  const sortedIndexes = rows
    .map((_, idx) => idx)
    .sort((a, b) => {
      const valA = rows[a][sortKey];
      const valB = rows[b][sortKey];
      if (valA < valB) return sortDirection === "asc" ? -1 : 1;
      if (valA > valB) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

  const handleInputChange = (idx, field, value, extra) => {
    setRows((prev) => {
      const updated = [...prev];
      if (field === "absent") {
        updated[idx].markAsAbsent = value;
      } else if (field === "marks") {
        updated[idx].totalCriteriaAchieved = value;
      } else if (field === "assignmentId") {
        updated[idx].assignmentId = value;
      } else if (field === "copy") {
        updated[idx].totalCriteriaAchieved = extra;
      }
      return updated;
    });
  };

  const handleBack = () => {
    // navigate(`/dashboard/marks_submission/${selectedSubject}`);
    navigate(-1);
  };

  const unitCode = location.state.unit.split(" ")[0];

  return (
    <div className="mark-submission-wrapper mt-4">
      <div className="header-actions is-flex button-value is-justify-content-space-between is-align-items-center mb-3">
        <strong className="highlight">
          Review and submit updated total marks for {unitCode}
        </strong>

        <div className="is-flex is-align-items-center">
          <button
            className="button is-primary is-outlined mr-2"
            onClick={handleBack}
          >
            Cancel
          </button>

          <button className="button is-success" onClick={submitMarks}>
            Submit marks
          </button>
        </div>
      </div>

      <div className="table-container marks-table-container">
        <table className="table is-hoverable mark-table">
          <colgroup>
            <col className="col-status" />
            <col className="col-number" />
            <col className="col-name" />
            <col className="col-absent" />
            <col className="col-marks" />
            <col className="col-assignment" />
          </colgroup>
          <thead>
            <tr className="table-row-fullwidth">
               <th
                style={{
                  display:
                    currentCentreType === "Lead" && isConsortiaUnit
                      ? "table-cell"
                      : "none", // Show only if both conditions are met
                }}
              >
                {currentCentreType === "Lead" && isConsortiaUnit ? "Centre number" : ""}
              </th>
              <th>Candidate number</th>
              <th className="nowrap">Candidate name</th>
              <th>Absent</th>
              {isPostStage3 ?
                <th style={{ width: '180px' }}>  <span>Last submitted</span>
                  <br />
                  <span>total mark</span><span className="icon" style={{ fill: '#0076BD', marginLeft: '4px', cursor: 'pointer', position: 'relative', top: '5px' }}>
                    <span title="This shows the most recent centre mark submitted during the moderation process. It does not include any mark changes as a result of moderation.">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="212121"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"></path></svg>
                    </span>
                  </span>
                </th> : <th>
                  <span>Original total</span>
                  <br />
                  <span>number of</span>
                  <br />
                  <span className="text-fields">criteria achieved</span>
                </th>}

              <th>Updated total number of criteria achieved</th>
              <th>Assignment</th>
            </tr>
          </thead>
          <tbody>
            {sortedIndexes.map((idx) => {
              const row = rows[idx];
              return (
                <tr
                  className={row.disableCandidate ? "disabled-row" : ""}
                  key={row.candidateNumber}
                >
                   {currentCentreType === "Lead" && isConsortiaUnit && (
                    <td className="col-number">{row.centreNumber}</td>
                  )}
                  <td>{row.candidateNumber}</td>
                  <td>{row.candidateName}</td>
                  <td>
                    <label className="checkbox">
                      <input
                        type="checkbox"
                        checked={row.markAsAbsent}
                        onChange={(e) =>
                          handleInputChange(idx, "absent", e.target.checked)
                        }
                        disabled={true}
                      />
                      Absent
                    </label>
                  </td>
                  <td style={{ paddingTop: '22px' }}>
                    {!row.disableCandidate && (
                      <div className="mark-input-wrapper">
                        <span className="existing-mark">
                          {row.existingTotalCriteriaScore}
                        </span>
                        <span>/ {row.totalMarks}</span>
                      </div>
                    )}
                  </td>
                  <td style={{ paddingTop: '22px' }}>
                    {!row.disableCandidate && (
                      <div className="mark-input-wrapper">
                        <span>
                          {" "}
                          <strong>{row.totalCriteriaAchieved}</strong> /{" "}
                          {row.totalMarks}
                        </span>
                      </div>
                    )}
                  </td>
                  <td>
                    {!row.markAsAbsent && <span>{row.assignmentId}</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarkSubmissionUpdateMarks;
